import React from "react";
import T from "prop-types";

function ZadostiGroupsPocet({ pocet = 0 }) {
  return pocet ? (
    <span className="b2b-ZadostiGroups-pocet">{pocet}</span>
  ) : null;
}

ZadostiGroupsPocet.propTypes = {
  pocet: T.number
};

export default React.memo(ZadostiGroupsPocet);
